import { FC } from "react";
import { Content } from "@prismicio/client";
import { SliceComponentProps } from "@prismicio/react";

/**
 * Props for `RelatedContent`.
 */
export type RelatedContentProps =
  SliceComponentProps<Content.RelatedContentSlice>;

/**
 * Component for "RelatedContent" Slices.
 */
const RelatedContent: FC<RelatedContentProps> = ({ slice }) => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
    >
      Placeholder component for related_content (variation: {slice.variation})
      Slices
    </section>
  );
};

export default RelatedContent;
